import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

import './Section.styles.less';

const NoGuestsSection = ({ onAddGuestGroup }) => (
  <div className="sc__guest-list__section no-guests">
    <div className="sc__guest-list__section__header">
      <h2 className="sc__guest-list__section__header__title">Other Guests</h2>
      <span className="sc__arrow-up" />
    </div>
    <div className="image__guestCards" />
    <h3>Your Guest List is Empty!</h3>
    <p>Once you create a guest list, you can easily drag and drop your guests onto each table</p>
    <ButtonV2 onClick={onAddGuestGroup}>+ Add Guests</ButtonV2>
  </div>
);

NoGuestsSection.propTypes = {
  onAddGuestGroup: PropTypes.func,
};

export default NoGuestsSection;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/GuestList/Section/NoGuestsSection.jsx